<template>
	<div class="relative flex flex-col gap-4 p-4 bg-white shadow dark:bg-mx-green-700 rounded-xl">
		<!-- Device Header -->
		<div class="flex justify-between gap-1">
			<h3 class="text-lg font-bold dark:text-white">
				{{ deviceName || 'Device' }}
			</h3>
			<div class="flex flex-col text-xs text-right text-mx-gray-500 dark:text-mx-gray-400">
				<p v-if="formattedMacAddress">
					MAC: <span class="font-semibold">{{ formattedMacAddress }}</span>
				</p>
				<p v-if="serialNumber">
					Serial: <span class="font-semibold">{{ serialNumber }}</span>
				</p>
			</div>
		</div>

		<!-- Tool Cards Grid -->
		<div class="flex flex-wrap items-stretch justify-center gap-4 lg:justify-start">
			<!-- Device Status Card -->
			<EquipmentDeviceStatus
				:mac-address="macAddress"
				:serial-number="serialNumber"
				:device-nms="deviceNms"
				:config="{ apiDomain: 'customer' }"
			/>

			<!-- Reboot Device Card -->
			<EquipmentDeviceReboot
				:mac-address="macAddress"
				:serial-number="serialNumber"
				:device-nms="deviceNms"
				:config="{ apiDomain: 'customer' }"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
const props = defineProps({
	macAddress: {
		type: String,
		required: true
	},
	deviceName: {
		type: String,
		default: ''
	},
	serialNumber: {
		type: [String, null] as PropType<string | null>,
		default: null
	},
	deviceNms: {
		type: String,
		default: ''
	}
})

const {
	macAddress, deviceName, serialNumber, deviceNms
} = toRefs(props)

const formattedMacAddress = computed(() => !macAddress.value ? 'N/A' : macAddress.value.toUpperCase())
</script>
